import { render } from "./insure-daily-premium-record.vue?vue&type=template&id=e77a8038&scoped=true&ts=true"
import script from "./insure-daily-premium-record.vue?vue&type=script&lang=ts"
export * from "./insure-daily-premium-record.vue?vue&type=script&lang=ts"

import "./insure-daily-premium-record.vue?vue&type=style&index=0&id=e77a8038&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e77a8038"]])

export default __exports__